import { TripStatus } from 'src/.gen/graphql';

export const rejectableSharedTripStatuses = [
  TripStatus.AwaitingAssignment,
  TripStatus.PendingNetworkConfirmation,
  TripStatus.Confirmed,
];
